const url = '/roles';
const Provider = 'Roles';
const dbModel = 'Roles';

export { url, Provider, dbModel };
